import HugggMap, { config as defaults } from '@huggg/maps-browser';

import { isMobileDevice } from '@huggg/bar-staff';
import loadGoogleMaps from 'utilities/googleMapsLoader';

class GoogleMapsService {
  _HugggMapInstance = null;
  _GMaps = null;
  _GMapsPromise = null;
  _initialisePromise = null;
  _mapElement = null;
  _libraries = [];
  _config = {};

  constructor(config = {}, libraries = ['geometry']) {
    /**
     * This is creating a static _instance. It assigns a property to the
     * GoogleMapsService _not_ an actual instance ofthe GoogleMapsService.
     * Confusing, and it's basically a shortcut to static props and methods.
     * `GoogleMapsService._instance`
     */
    if (!GoogleMapsService._instance) {
      GoogleMapsService._instance = this;
      this._libraries = libraries;
      this._mapElement = this._createMapInstance();

      this._GMapsPromise = loadGoogleMaps();

      this._initialisePromise = this._initialise();

      this._config = {
        ...defaults,
        gestureHandling: 'greedy',
        minZoom: 4,
        restriction: null,
        zoom: isMobileDevice() ? 4 : 6,
        zoomControl: false,
        ...config,
      };
    }

    return GoogleMapsService._instance;
  }

  initialise = () => {
    return this._initialisePromise;
  };
  mount = (element) => this._HugggMapInstance.reattachToDOM(element);
  recenter = () => this._HugggMapInstance.resetToUserLocation();
  setLocations = (locations) =>
    this._HugggMapInstance.updatePurchaseLocationMarkers(locations);
  setupUserLocation = () =>
    this._HugggMapInstance.displayUserLocation().then(this.recenter);
  unmount = () => this._HugggMapInstance.detachFromDOM();

  _createMapInstance = () => {
    const div = document.createElement('div');

    div.style.height = '20px';
    div.style.width = '20px';
    div.style.position = 'absolute';
    div.style.left = '-9999px';

    document.body.appendChild(div);

    return div;
  };

  _initialise = async () => {
    this._GMaps = await this._GMapsPromise;

    this._HugggMapInstance = await HugggMap.init(
      this._GMaps,
      this._mapElement,
      this._config,
    );

    this._mapElement.style.height = '100%';
    this._mapElement.style.width = '100%';
    this._mapElement.style.position = 'relative';
    this._mapElement.style.left = null;

    this._HugggMapInstance.detachFromDOM();
  };
}

export default GoogleMapsService;
